interface SidebarProps {
 children: React.ReactNode;
 sticky?: boolean;
}

export function Sidebar({ children, sticky = true }: SidebarProps) {
 return (
 <aside className={`${sticky ? "lg:sticky lg:top-24" : ""} space-y-6`}>
 {children}
 </aside>
 );
}

interface SidebarCardProps {
 title: string;
 children: React.ReactNode;
}

export function SidebarCard({ title, children }: SidebarCardProps) {
 return (
 <div className="rounded-xl p-px bg-gradient-to-b from-border to-transparent">
 <div className="bg-card rounded-[calc(0.75rem-1px)] p-5">
 <h3 className="font-semibold text-foreground mb-3 text-sm uppercase tracking-wider">{title}</h3>
 {children}
 </div>
 </div>
 );
}
